import { Icon, Loading } from '@startlibs/components';
import { getColor, media, customTheme } from '@startlibs/utils';
import { lighten } from 'polished';
import styled, { css } from 'styled-components';

export const AttachmentBox = styled.div `
  padding: 0.5rem 1.5rem 0.5rem 4.5rem;
  background: ${getColor('lightBlue')};
  border-radius: 5px;
  margin-top: 1rem;
  border: 1px solid rgba(41, 122, 163, 0.25);
  position: relative;
  min-height: 5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  :only-child, :first-child {
    margin-top: 0;
  }
  ${props => props.failedUpload && css`
    background: ${props => lighten(0.51, props.theme.colors.alert)};
    border: 1px solid #e09f9f;
  `}
  ${media.max(520)`
    padding: 1rem;
    display: block;
    ${props => props.nonCompliantDeleteFileBox && css`
      min-height: 2rem;
    `}
    ${props => props.isApp && css`
      padding: 0.75rem 3rem 1rem 1rem;
      ${AttachmentIcon} {
        left: inherit;
        right: 1rem;
      }
    `}
  `}
  ${customTheme("AttachmentBox")};
`
export const AttachmentInfoContainer = styled.div `
  flex-grow: 1;
  margin-right: 1.5rem;
`
export const AttachmentIcon = styled(Icon) `
  font-size: 36px;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4.5rem;
  text-align: center;
  ${media.max(520)`
    font-size: 28px;
    top: 0.75rem;
    left: 1rem;
    transform: none;
    width: auto;
    &.desktop-only {
      display: none;
    }
  `}
`
export const AttachmentDescription = styled.div `
  font-size: 13px;
  width: 100%;
  input {
    width: calc(100% - 90px);
    margin-top: -2px;
    height: 2rem;
    font-size: 13px;
    padding: 0 0.5rem;
  }
  .link {
    font-size: 12px;
    white-space: nowrap;
  }
  ${media.max(520)`
    font-size: 12px;
    display: block;
    input {
      margin: 0.5rem 0;
      width: 100%;
    }
  `}
`
export const AttachmentDetails = styled.div `
  margin-top: 2px;
`
export const DropdownIcon = styled(Icon)`
`
export const AttachmentActions = styled.div `
  flex-shrink: 0;
  .buttons-wrapper {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    order: 3;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  ${media.max(520)`
    justify-content: flex-end;
    margin: -0.25rem -0.25rem 0.25rem 0;
    padding-left: 2.25rem;
  `}
`

export const UploadedDate = styled.div`
  color: ${getColor('gray150')};
  text-align: right;
  margin-top: .25rem;
  font-size: 11px;
  display: block;
`

export const TextButton = styled.a`
  text-decoration: none;
  color: ${getColor('main')};
  padding: 0.25rem 0.75rem;
  font-weight: 600;
  border-radius: 5px;
  user-select: none;
  position:relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2rem;
  background-color: rgba(0, 139, 210, 0.1);
  flex-shrink: 0;
  & ~ & {
    margin-left: 0.75rem;
  }
  :hover {
    background-color: rgba(0, 139, 210, 0.15);
  }
  :active {
    background-color: rgba(0, 139, 210, 0.2);
  }
  ${props => props.focused && css`
    background-color: rgba(0, 139, 210, 0.1);
    color: ${getColor('main')};
  `}
  ${props => props.isLoading && css`
    background-color: rgba(0, 139, 210, 0.1);
    color: ${getColor('main')};
    pointer-events: none;
  `}
  ${props => props.started && css`
    background-color: ${props => lighten(0.4, props.theme.colors.success)};
    color: ${getColor('success')};
    pointer-events: none;
  `}
  ${props => props.disabled && css`
    color: ${getColor('gray90')};
    pointer-events: none;
  `}
  ${Loading} {
    display: inline-block;
    margin-right: 4px;
    vertical-align: sub;
  }
  ${Icon} {
    font-size: 18px;
    margin-right: 4px;
    vertical-align: bottom;
  }
  ${DropdownIcon} {
    font-size: 10px;
    margin-left: 0.25rem;
    margin-right: 0;
    transform: translateY(1px);
    vertical-align: baseline;
  }
  ${customTheme("AttachmentBoxButton")};
`
export const DropdownButton = styled(TextButton)`
  padding: 0.25rem;
  width: 2rem;
  text-align: center;
  ${TextButton} ~ & {
    margin-left: 0.75rem;
  }
  ${DropdownIcon} {
    font-size: 12px;
    margin-left: 0;
  }
`
export const UploadingStatus = styled.div `
  flex-shrink: 0;
  min-width: 14rem;
  order: 3;
  ${media.max(520)`
    margin: -4px 0 0.5rem 0;
    padding-left: 2.5rem;
  `}
  .files-count {
    margin-top: 0.25rem;
  }
  .error {
    color: ${getColor('alert')};
    margin-right: 0.25rem;
    margin-left: 0;
  }
`
export const ProgressBar = styled.div`
  height: 8px;
  width: 100%;
  border-radius: 30px;
  background-color: rgba(0,0,0,0.075);
  overflow: hidden;
  margin-top: 4px;
  user-select: none;
  :after {
    content: '';
    width: ${props => props.progress || 0}%;
    height: 100%;
    min-width: 4px;
    display: block;
    border-radius: 30px;
    background-color: ${getColor('main')};
    transition: 0.25s linear;
  }
  ${props => props.completed && css`
    :after {
      background-color: ${getColor('success')};
    }
    width: 100%;
  `}
  ${props => props.failed && css`
    :after {
      background-color: ${getColor('alert')};
    }
  `}
`
export const ProgressDetails = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  ${props => props.failed && css`
    color: ${getColor('alert')};
    display: block;
    ${media.min(521)`
      text-align: right;
    `}
  `}
  a {
    margin-left: 0.25rem;
  }
`
